import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let AccountSecurityOption: LazyOption = createLazyOption(
    {
        key: 'accountSecurity',
        titleStringKey: 'options_premium_subTitleAccountSecurity',
        searchTermsStringKey: 'options_premium_subTitleAccountSecurity',
        hideTitleInFullOptions: false,
        isHidden: () =>
            !isFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
export default AccountSecurityOption;
